import client from '../client';

export const readCommonDashboard = ({ date_range }) =>
    client.get(`/api/dashboard/common`, {
        params: {
            date_range
        }
    });
